<template>
  <div class="container">
    <div class="row">
      <div class=" col-md-offset-4 col-md-4 content-box login">
        <div class="row">
          <div class="col-md-12 text-center logo-login">
            <img
              class="bloqueia-arrasto"
              src="@/assets/img/logo-azul.png"
              alt="Logo"
            />
          </div>
        </div>

        <div class="row">
          <hr />
        </div>

        <form @submit.prevent="enviarFormulario">
          <div class="row">
            <div class="col-md-12">
              <meta-email
                id="email"
                name="email"
                label="E-mail"
                v-model="email"
                placeholder="Insira seu e-mail"
              ></meta-email>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <meta-password
                id="senha"
                name="senha"
                label="Senha"
                v-model="password"
                placeholder="Insira sua senha"
              ></meta-password>
            </div>
          </div>

          <div class="row justify-content-end">
            <div class="col-md-12 btn-login">
              <button type="submit" class="btn btn-primary btn-block">
                Entrar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <notifications group="login" />
  </div>
</template>

<style lang="scss" scoped>
.content-box.login {
  margin-top: 10%;
  margin-bottom: 50px;
}

.logo-login {
  margin: 35px 0;
}

.btn-primary {
  width: 100%;
  background-color: #2d56a8;
}

h3,
h4,
h5,
h6 {
  color: #2d56a8;
}
</style>

<script>
import MetaPassword from "meta-password";
import MetaEmail from "meta-email";
import Utils from "../mixins/utils.js";

export default {
  name: "Login",

  components: {
    MetaPassword,
    MetaEmail
  },

  mixins: [Utils],

  data() {
    return {
      password: "",
      email: ""
    };
  },

  computed: {
    usuario() {
      return this.email.replace("@meta.com.br", "");
    }
  },

  mounted() {
    document.getElementById("email").focus();

    document.getElementById("app").classList.add("login-image");
  },

  destroyed() {
    document.getElementById("app").classList.remove("login-image");
  },

  methods: {
    async enviarFormulario() {
      if (this.email && this.password) {
        try {
          await this.login();
        } catch (e) {
          return this.customAlert(
            "Ocorreu um erro!",
            "Entre em contato com o administrador do sistema.",
            "error"
          );
        }
      } else {
        this.customAlert(
          "Atenção!",
          "Por favor, preencha todos os campos.",
          "warning"
        );
      }
    },

    async login() {
      this.$parent.loading = true;

      const { data: response } = await this.$http.post("/login", {
        username: this.usuario,
        password: this.password
      });

      this.$parent.loading = false;

      if (!response.access_token) {
        return this.customAlert(
          "Atenção!",
          "Usuário ou senha inválidos.",
          "warning"
        );
      }

      this.$localStorage.set("user", JSON.stringify(response));
      this.$router.push({ path: "/denuncia/lista-denuncias" });
    },

    logout() {
      this.$localStorage.set("user", "");
      this.$router.push({ name: "Login" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue